import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Lock, Zap, Shield, Eye, ArrowRight, Clock, CheckCircle } from 'lucide-react';
const orderBumps = [{
  id: 1,
  emoji: '⚡',
  tag: 'OFERTA ÚNICA EN ESTA PÁGINA',
  tagColor: '#1B5E3B',
  tagBg: '#EAF4EE',
  borderColor: '#1B5E3B',
  accentColor: '#1B5E3B',
  bg: 'linear-gradient(135deg, #F0FAF4 0%, #E8F5ED 100%)',
  image: 'https://cdn.magicpatterns.com/uploads/nzaVophbfbpuoH6zth2uvL/ORB1.png',
  title: '¡SÍ! Activa mi Motor de IA, para crear mi PDF en 5 Minutos.',
  subtitle: 'Ahorra 10 horas de diseño',
  descriptionParts: [{
    text: '¡Multiplica tu velocidad x10! ⚡ ¿Por qué pasar horas frente a la pantalla si puedes usar la tecnología del 2026 a tu favor? Añade el "Kit Impulso IA" y accede a la lista secreta de las 7 herramientas de Inteligencia Artificial que generan cuadernos educativos completos en menos de 5 minutos. Incluye tutoriales flash para crear tu PDF en '
  }, {
    text: 'una herramienta secreta',
    redacted: true
  }, {
    text: ', generar imágenes educativas únicas con IA y clonar páginas web de venta en menos de una hora. Deja que la tecnología trabaje por ti por solo $9.'
  }],
  price: '$9.00',
  cta: 'AÑADIR ESTE BONO POR $9'
}, {
  id: 2,
  emoji: '💎',
  tag: 'OFERTA ÚNICA EN ESTA PÁGINA',
  tagColor: '#8B6914',
  tagBg: '#FDF3DC',
  borderColor: '#C9973A',
  accentColor: '#C9973A',
  bg: 'linear-gradient(135deg, #FEFAF0 0%, #FDF3DC 100%)',
  image: 'https://cdn.magicpatterns.com/uploads/8x3YucR8wiAqWtKyQD26Jx/ORB2.png',
  title: '¡SÍ! Asegura mi éxito con la Bóveda de los 100 Nichos de Oro',
  subtitle: 'No lances a ciegas',
  descriptionParts: [{
    text: '¡No lances a ciegas! 💎 El 90% de las personas fallan porque intentan vender lo que ellas "creen" que funciona. Añade a tu pedido "La Bóveda de los 100 Nichos de Oro" y recibe la lista exacta de los 100 temas educativos con mayor volumen de ventas en '
  }, {
    text: 'Facebook y Amazon EE.UU.',
    redacted: true
  }, {
    text: ' — desde cuadernos para niños con Autismo hasta caligrafía bilingüe para estados específicos. Ve a la segura y elige un ganador desde el primer día por solo $9.'
  }],
  price: '$9.00',
  cta: 'AÑADIR ESTE BONO POR $9'
}, {
  id: 3,
  emoji: '🌍',
  tag: 'OFERTA ÚNICA EN ESTA PÁGINA',
  tagColor: '#1B3A5E',
  tagBg: '#EAF0FA',
  borderColor: '#2D5A8A',
  accentColor: '#2D5A8A',
  bg: 'linear-gradient(135deg, #F0F4FA 0%, #E8EFF8 100%)',
  image: 'https://cdn.magicpatterns.com/uploads/1ohVn5PNZtokJucVL9cTbe/ORB3.png',
  title: '¡SÍ! Quiero estar en todas partes. Activa mi Mapa de Canales',
  subtitle: 'Gana en Dólares desde tu sala',
  descriptionParts: [{
    text: '¡No dependas de un solo lugar! 🌍 ¿Sabías que puedes vender el mismo PDF en 5 plataformas diferentes al mismo tiempo? Añade el "Mapa Maestro de Canales" y descubre la ruta exacta para listar tus productos en '
  }, {
    text: 'Etsy, eBay, Amazon KDP',
    redacted: true
  }, {
    text: ' y aprovechar el tráfico gratuito de '
  }, {
    text: 'Facebook Marketplace',
    redacted: true
  }, {
    text: ' y grupos locales en EE.UU. Incluye la guía de cómo configurar tus pagos para que el dinero llegue directo a tu cuenta sin importar dónde estés. Asegura tus ventas en todas partes por solo $9.'
  }],
  price: '$9.00',
  cta: 'AÑADIR ESTE BONO POR $9'
}];
function useCountdown(targetMinutes: number) {
  const [time, setTime] = useState(targetMinutes * 60);
  useEffect(() => {
    const id = setInterval(() => setTime(t => t > 0 ? t - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const m = String(Math.floor(time / 60)).padStart(2, '0');
  const s = String(time % 60).padStart(2, '0');
  return {
    m,
    s
  };
}
interface PriceSectionProps {
  selected: number[];
  toggleBump: (id: number) => void;
  totalPrice: number;
}
export function PriceSection({
  selected,
  toggleBump,
  totalPrice
}: PriceSectionProps) {
  const {
    m,
    s
  } = useCountdown(17);
  const basePrice = 6.36;
  const bumpPrice = 9;
  // bump id: 1=IA Flash Builder, 2=Bóveda 100 Nichos, 3=Mapa Maestro de Canales
  const getCheckoutUrl = (sel: number[]): string => {
    const key = [...sel].sort().join(',');
    const urls: Record<string, string> = {
      '': 'https://www.betterbysteps.com/cart/44220071608413:1',
      '1': 'https://www.betterbysteps.com/cart/44220072689757:1',
      '2': 'https://www.betterbysteps.com/cart/44220093038685:1',
      '3': 'https://www.betterbysteps.com/cart/44220094414941:1',
      '1,2': 'https://www.betterbysteps.com/cart/44220084813917:1',
      '1,3': 'https://www.betterbysteps.com/cart/44220072689757:1',
      '2,3': 'https://www.betterbysteps.com/cart/44220099362909:1',
      '1,2,3': 'https://www.betterbysteps.com/cart/44220089237597:1'
    };
    return urls[key] ?? 'https://www.betterbysteps.com/cart/44220071608413:1';
  };
  const checkoutUrl = getCheckoutUrl(selected);
  const includedItems = [{
    name: 'Guía Maestra "Imperio de Digital Workbooks"',
    compare: '$97',
    price: '$6.36',
    isFree: false
  }, {
    name: 'Bono 1: Plan Anti‑Parálisis 48h',
    compare: '$47',
    price: 'FREE',
    isFree: true
  }, {
    name: 'Bono 2: Cierra‑Ventas Express',
    compare: '$47',
    price: 'FREE',
    isFree: true
  }];
  return <section id="precio" style={{
    background: 'linear-gradient(160deg, #1C1C1E 0%, #1B5E3B 100%)',
    padding: '80px 24px',
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-116">
      <div style={{
      position: 'absolute',
      top: '-120px',
      right: '-120px',
      width: '500px',
      height: '500px',
      background: 'rgba(201,151,58,0.07)',
      borderRadius: '50%',
      pointerEvents: 'none'
    }} data-id="element-117" />

      <div style={{
      maxWidth: '680px',
      margin: '0 auto',
      position: 'relative',
      textAlign: 'center'
    }} data-id="element-118">
        {/* Countdown */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        background: 'rgba(201,151,58,0.15)',
        border: '1px solid rgba(201,151,58,0.4)',
        borderRadius: '100px',
        padding: '10px 20px',
        marginBottom: '36px'
      }} data-id="element-119">
          <Clock size={16} style={{
          color: '#C9973A'
        }} data-id="element-120" />
          <span style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '13px',
          fontWeight: 700,
          color: '#E8DDD0'
        }} data-id="element-121">
            Precio especial expira en:
          </span>
          <span style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '18px',
          fontWeight: 900,
          color: '#C9973A'
        }} data-id="element-122">
            {m}:{s}
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-123">
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(28px, 4vw, 50px)',
          fontWeight: 900,
          color: '#FAFAF6',
          marginBottom: '20px',
          lineHeight: 1.2
        }} data-id="element-124">
            Dentro de un año, vas a mirar atrás.
          </h2>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '18px',
          color: '#E8DDD0',
          lineHeight: 1.9,
          marginBottom: '16px'
        }} data-id="element-125">
            Y vas a recordar este momento. El momento en que decidiste que ya
            era suficiente. Que tus hijos merecían una mamá presente, no una
            mamá agotada.
          </p>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '18px',
          color: '#E8DDD0',
          lineHeight: 1.9,
          marginBottom: '44px'
        }} data-id="element-126">
            La pregunta no es si puedes permitirte esto.{' '}
            <strong style={{
            color: '#C9973A'
          }} data-id="element-127">
              La pregunta es si puedes permitirte seguir igual.
            </strong>
          </p>
        </motion.div>

        {/* Price Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.93
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} style={{
        background: '#FAFAF6',
        borderRadius: '24px',
        padding: '44px 36px',
        boxShadow: '0 40px 80px rgba(0,0,0,0.35)',
        marginBottom: '28px',
        position: 'relative'
      }} data-id="element-128">
          <div style={{
          position: 'absolute',
          top: '-1px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(90deg, #1B5E3B, #2D7A52)',
          color: '#fff',
          fontFamily: "'Lato', sans-serif",
          fontSize: '11px',
          fontWeight: 900,
          letterSpacing: '2px',
          padding: '7px 22px',
          borderRadius: '0 0 12px 12px',
          whiteSpace: 'nowrap'
        }} data-id="element-129">
            PRECIO ESPECIAL DE HOY
          </div>

          {/* Dynamic price display */}
          <div style={{
          marginTop: '14px',
          marginBottom: '24px'
        }} data-id="element-130">
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '13px',
            color: '#8A8A8A',
            marginBottom: '2px'
          }} data-id="element-131">
              Valor real:{' '}
              <span style={{
              textDecoration: 'line-through'
            }} data-id="element-132">
                $191
              </span>
            </p>
            <AnimatePresence mode="wait" data-id="element-133">
              <motion.div key={totalPrice} initial={{
              scale: 1.2,
              color: '#C9973A'
            }} animate={{
              scale: 1,
              color: '#1B5E3B'
            }} exit={{
              scale: 0.9,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(72px, 14vw, 96px)',
              fontWeight: 900,
              lineHeight: 1,
              marginBottom: '4px'
            }} data-id="element-134">
                ${totalPrice.toFixed(2)}
              </motion.div>
            </AnimatePresence>
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '13px',
            color: '#8A8A8A',
            fontStyle: 'italic'
          }} data-id="element-135">
              {selected.length > 0 ? `$${basePrice.toFixed(2)} base + ${selected.length} bono${selected.length > 1 ? 's' : ''} adicional${selected.length > 1 ? 'es' : ''}` : 'Pago único · Acceso de por vida'}
            </p>
          </div>

          {/* Order Summary Box */}
          <div style={{
          textAlign: 'left',
          marginBottom: '28px',
          background: '#F7F7F2',
          border: '1px solid #E8DDD0',
          borderRadius: '14px',
          overflow: 'hidden'
        }} data-id="element-136">
            <div style={{
            background: '#1C1C1E',
            padding: '10px 18px'
          }} data-id="element-137">
              <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '11px',
              fontWeight: 900,
              letterSpacing: '2px',
              color: '#E8DDD0',
              textTransform: 'uppercase',
              margin: 0
            }} data-id="element-138">
                Resumen de tu orden
              </p>
            </div>

            <div style={{
            padding: '14px 18px',
            borderBottom: '1px dashed #E8DDD0'
          }} data-id="element-139">
              <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '10px',
              fontWeight: 700,
              color: '#8A8A8A',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              marginBottom: '10px'
            }} data-id="element-140">
                Incluido en tu paquete
              </p>
              {includedItems.map((item, i) => <div key={i} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
              marginBottom: '9px'
            }} data-id="element-141">
                  <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                flex: 1,
                minWidth: 0
              }} data-id="element-142">
                    <CheckCircle size={14} style={{
                  color: '#1B5E3B',
                  flexShrink: 0
                }} data-id="element-143" />
                    <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '13px',
                  color: '#1C1C1E',
                  lineHeight: 1.3
                }} data-id="element-144">
                      {item.name}
                    </span>
                  </div>
                  <div style={{
                textAlign: 'right',
                flexShrink: 0
              }} data-id="element-145">
                    <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '11px',
                  color: '#8A8A8A',
                  textDecoration: 'line-through',
                  display: 'block'
                }} data-id="element-146">
                      {item.compare}
                    </span>
                    <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '12px',
                  fontWeight: 900,
                  color: item.isFree ? '#1B5E3B' : '#C9973A'
                }} data-id="element-147">
                      {item.price}
                    </span>
                  </div>
                </div>)}
            </div>

            {selected.length > 0 && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} style={{
            padding: '14px 18px',
            borderBottom: '1px dashed #E8DDD0'
          }} data-id="element-148">
                <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '10px',
              fontWeight: 700,
              color: '#C9973A',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              marginBottom: '10px'
            }} data-id="element-149">
                  Bonos adicionales seleccionados
                </p>
                {orderBumps.filter(b => selected.includes(b.id)).map(bump => <motion.div key={bump.id} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -10
            }} transition={{
              duration: 0.2
            }} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
              marginBottom: '9px'
            }} data-id="element-150">
                      <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                flex: 1,
                minWidth: 0
              }} data-id="element-151">
                        <span style={{
                  fontSize: '13px',
                  flexShrink: 0
                }} data-id="element-152">
                          {bump.emoji}
                        </span>
                        <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '13px',
                  color: '#1C1C1E',
                  lineHeight: 1.3
                }} data-id="element-153">
                          {bump.title.replace('¡SÍ! ', '')}
                        </span>
                      </div>
                      <div style={{
                textAlign: 'right',
                flexShrink: 0
              }} data-id="element-154">
                        <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '11px',
                  color: '#8A8A8A',
                  textDecoration: 'line-through',
                  display: 'block'
                }} data-id="element-155">
                          $47
                        </span>
                        <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '12px',
                  fontWeight: 900,
                  color: '#C9973A'
                }} data-id="element-156">
                          $9.00
                        </span>
                      </div>
                    </motion.div>)}
              </motion.div>}

            <div style={{
            padding: '10px 18px',
            borderBottom: '1px dashed #E8DDD0'
          }} data-id="element-157">
              <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px'
            }} data-id="element-158">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }} data-id="element-159">
                  <CheckCircle size={14} style={{
                  color: '#1B5E3B',
                  flexShrink: 0
                }} data-id="element-160" />
                  <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '13px',
                  fontWeight: 700,
                  color: '#1C1C1E'
                }} data-id="element-161">
                    Garantía de devolución 7 días
                  </span>
                </div>
                <span style={{
                fontFamily: "'Lato', sans-serif",
                fontSize: '12px',
                fontWeight: 900,
                color: '#1B5E3B'
              }} data-id="element-162">
                  INCLUIDA
                </span>
              </div>
            </div>

            <div style={{
            padding: '14px 18px',
            background: '#EAF4EE'
          }} data-id="element-163">
              <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }} data-id="element-164">
                <div data-id="element-165">
                  <p style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '11px',
                  fontWeight: 700,
                  color: '#4A4A4A',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  margin: '0 0 2px'
                }} data-id="element-166">
                    Total hoy
                  </p>
                  <p style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '11px',
                  color: '#8A8A8A',
                  margin: 0
                }} data-id="element-167">
                    Valor real:{' '}
                    <span style={{
                    textDecoration: 'line-through'
                  }} data-id="element-168">
                      $191+
                    </span>
                  </p>
                </div>
                <AnimatePresence mode="wait" data-id="element-169">
                  <motion.span key={totalPrice} initial={{
                  scale: 1.25,
                  color: '#C9973A'
                }} animate={{
                  scale: 1,
                  color: '#1B5E3B'
                }} exit={{
                  scale: 0.85,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} style={{
                  fontFamily: "'Playfair Display', serif",
                  fontSize: '32px',
                  fontWeight: 900
                }} data-id="element-170">
                    ${totalPrice.toFixed(2)}
                  </motion.span>
                </AnimatePresence>
              </div>
            </div>
          </div>

          {/* CTA #1 — above bumps */}
          <a href={checkoutUrl} style={{
          textDecoration: 'none',
          display: 'block'
        }} data-id="element-171">
            <button className="cta-pulse" style={{
            width: '100%',
            background: 'linear-gradient(135deg, #1B5E3B, #2D7A52)',
            color: '#fff',
            fontFamily: "'Lato', sans-serif",
            fontWeight: 900,
            fontSize: '17px',
            letterSpacing: '0.5px',
            padding: '20px 36px',
            borderRadius: '12px',
            border: '2px solid #C9973A',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            marginBottom: '12px'
          }} data-id="element-172">
              SÍ, ESTOY LISTA — PAGAR ${totalPrice.toFixed(2)}
              <ArrowRight size={19} data-id="element-173" />
            </button>
          </a>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '12px',
          color: '#8A8A8A',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '5px',
          margin: '0 0 28px'
        }} data-id="element-174">
            <Lock size={12} data-id="element-175" />
            Pago 100% seguro · Acceso inmediato
          </p>

          {/* ── BONOS ADICIONALES ── */}
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          textAlign: 'left'
        }} data-id="element-176">
            {orderBumps.map((bump, i) => {
            const isSelected = selected.includes(bump.id);
            return <motion.div key={bump.id} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} style={{
              background: bump.bg,
              border: `2px dashed ${isSelected ? bump.borderColor : '#D0D0D0'}`,
              borderRadius: '16px',
              overflow: 'hidden',
              transition: 'border-color 0.25s, box-shadow 0.25s',
              boxShadow: isSelected ? `0 4px 20px ${bump.borderColor}30` : '0 2px 8px rgba(0,0,0,0.06)',
              position: 'relative'
            }} data-id="element-177">
                  {/* Shimmer */}
                  <motion.div animate={{
                x: ['-120%', '220%'],
                opacity: [0, 0.55, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                repeatDelay: 4 + i * 1.8,
                ease: 'easeInOut'
              }} style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '35%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
                pointerEvents: 'none',
                zIndex: 1,
                transform: 'skewX(-12deg)'
              }} data-id="element-178" />

                  {/* Tag */}
                  <div style={{
                background: bump.tagBg,
                borderBottom: `1px solid ${bump.borderColor}30`,
                padding: '6px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }} data-id="element-179">
                    <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '10px',
                  fontWeight: 900,
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: bump.tagColor
                }} data-id="element-180">
                      {bump.tag}
                    </span>
                    <span style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '10px',
                  fontWeight: 700,
                  color: bump.accentColor
                }} data-id="element-181">
                      Solo por $9.00
                    </span>
                  </div>

                  {/* Body */}
                  <div style={{
                padding: '18px 20px'
              }} data-id="element-182">
                    <img src={bump.image} alt={bump.title} style={{
                  width: '100%',
                  height: '160px',
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  borderRadius: '10px',
                  boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
                  display: 'block',
                  marginBottom: '16px'
                }} data-id="element-183" />

                    <div style={{
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'flex-start'
                }} data-id="element-184">
                      <div onClick={() => toggleBump(bump.id)} style={{
                    width: '22px',
                    height: '22px',
                    borderRadius: '6px',
                    border: `2px solid ${bump.borderColor}`,
                    background: isSelected ? bump.accentColor : '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    cursor: 'pointer',
                    marginTop: '2px',
                    transition: 'background 0.2s'
                  }} data-id="element-185">
                        {isSelected && <CheckCircle size={13} style={{
                      color: '#fff'
                    }} data-id="element-186" />}
                      </div>
                      <div style={{
                    flex: 1
                  }} data-id="element-187">
                        <p style={{
                      fontFamily: "'Lato', sans-serif",
                      fontSize: '10px',
                      fontWeight: 700,
                      color: bump.accentColor,
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      marginBottom: '4px'
                    }} data-id="element-188">
                          {bump.emoji} Altamente Recomendado
                        </p>
                        <h4 style={{
                      fontFamily: "'Playfair Display', serif",
                      fontSize: '15px',
                      fontWeight: 700,
                      color: '#1C1C1E',
                      lineHeight: 1.3,
                      margin: '0 0 4px'
                    }} data-id="element-189">
                          {bump.title}
                        </h4>
                        <p style={{
                      fontFamily: "'Lato', sans-serif",
                      fontSize: '12px',
                      color: bump.accentColor,
                      fontWeight: 700,
                      margin: 0
                    }} data-id="element-190">
                          {bump.subtitle}
                        </p>
                      </div>
                    </div>

                    <p style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '13px',
                  color: '#4A4A4A',
                  lineHeight: 1.75,
                  margin: '14px 0'
                }} data-id="element-191">
                      {bump.descriptionParts.map((part, idx) => part.redacted ? <span key={idx} title="Revelado al comprar" style={{
                    filter: 'blur(4px)',
                    userSelect: 'none',
                    cursor: 'default',
                    fontWeight: 700,
                    color: '#1C1C1E'
                  }} data-id="element-192">
                            {part.text}
                          </span> : <span key={idx} data-id="element-193">{part.text}</span>)}
                    </p>

                    <button onClick={() => toggleBump(bump.id)} style={{
                  width: '100%',
                  background: isSelected ? bump.accentColor : '#fff',
                  color: isSelected ? '#fff' : bump.accentColor,
                  fontFamily: "'Lato', sans-serif",
                  fontWeight: 900,
                  fontSize: '12px',
                  letterSpacing: '1px',
                  padding: '11px 16px',
                  borderRadius: '8px',
                  border: `2px solid ${bump.borderColor}`,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '7px',
                  transition: 'all 0.2s'
                }} data-id="element-194">
                      {isSelected ? <>
                          <CheckCircle size={14} data-id="element-195" /> AÑADIDO — OFERTA ÚNICA EN
                          ESTA PÁGINA
                        </> : <>{bump.cta}</>}
                    </button>
                  </div>
                </motion.div>;
          })}
          </div>

          {/* CTA #2 — below bumps, also dynamic */}
          <div style={{
          marginTop: '28px'
        }} data-id="element-196">
            <a href={checkoutUrl} style={{
            textDecoration: 'none',
            display: 'block'
          }} data-id="element-197">
              <button className="cta-pulse" style={{
              width: '100%',
              background: 'linear-gradient(135deg, #1B5E3B, #2D7A52)',
              color: '#fff',
              fontFamily: "'Lato', sans-serif",
              fontWeight: 900,
              fontSize: '17px',
              letterSpacing: '0.5px',
              padding: '20px 36px',
              borderRadius: '12px',
              border: '2px solid #C9973A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: '12px'
            }} data-id="element-198">
                SÍ, ESTOY LISTA — PAGAR ${totalPrice.toFixed(2)}
                <ArrowRight size={19} data-id="element-199" />
              </button>
            </a>
            <p style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '12px',
            color: '#8A8A8A',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',
            margin: 0
          }} data-id="element-200">
              <Lock size={12} data-id="element-201" />
              Pago 100% seguro · Acceso inmediato
            </p>
          </div>
        </motion.div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '10px',
        marginBottom: '24px'
      }} data-id="element-202">
          {[{
          icon: <Lock size={14} data-id="element-203" />,
          text: 'Pago Seguro'
        }, {
          icon: <Zap size={14} data-id="element-204" />,
          text: 'Acceso Inmediato'
        }, {
          icon: <Shield size={14} data-id="element-205" />,
          text: 'Garantia 7 dias'
        }, {
          icon: <Eye size={14} data-id="element-206" />,
          text: '100% Privado'
        }].map((badge, i) => <div key={i} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          background: 'rgba(250,250,246,0.1)',
          border: '1px solid rgba(250,250,246,0.2)',
          borderRadius: '100px',
          padding: '8px 14px',
          color: '#E8DDD0',
          fontFamily: "'Lato', sans-serif",
          fontSize: '12px',
          fontWeight: 700
        }} data-id="element-207">
              {badge.icon}
              {badge.text}
            </div>)}
        </motion.div>

        {/* Final emotional close */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: '15px',
        fontStyle: 'italic',
        color: 'rgba(232,221,208,0.7)',
        lineHeight: 1.7
      }} data-id="element-208">
          "Tus hijos no necesitan una mamá perfecta. Necesitan una mamá libre."
        </motion.p>
      </div>
    </section>;
}